import { Menu as MenuIcon } from '@mui/icons-material';
import { AppBar, Box, Drawer, IconButton, MenuItem, Select, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import backgroundImage from '../images/background.jpg';
import ChatBot from './ChatBot';
import Navigation from './Navigation';

const drawerWidth = 280;
const chatWidth = 380;

const Layout = ({ children }) => {
  const { organizations, currentOrg, changeOrg } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{
      display: 'flex',
      minHeight: '100vh',
      position: 'relative',
      color: 'white',
      '&::before': {
        content: '""',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        filter: 'brightness(0.3)',
        zIndex: -2,
      },
      '&::after': {
        content: '""',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
      }
    }}>
      <AppBar
        position="fixed"
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
          ml: { md: `${drawerWidth}px` },
          background: 'rgba(255, 255, 255, 0.08)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          boxShadow: 'none',
          borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div" sx={{ fontFamily: 'Inter, sans-serif' }}>
            СФЕРА CRM
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          {organizations && organizations.length > 0 && (
            <Select
              value={currentOrg || ''}
              onChange={(e) => changeOrg(e.target.value)}
              variant="outlined"
              size="small"
              sx={{
                color: 'rgba(255,255,255,0.92)',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255,255,255,0.18)' },
                '& .MuiSvgIcon-root': { color: 'rgba(255,255,255,0.92)' },
                minWidth: 120
              }}
            >
              {organizations.map((org) => (
                <MenuItem key={org.id} value={org.id}>{org.name}</MenuItem>
              ))}
            </Select>
          )}
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
      >
        {/* Мобильная навигация */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              background: 'transparent',
              border: 'none',
            },
          }}
        >
          <Navigation />
        </Drawer>

        {/* Десктопная навигация */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', md: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              background: 'transparent',
              border: 'none',
            },
          }}
          open
        >
          <Navigation />
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          px: { xs: 1, sm: 3 },
          py: { xs: 2, sm: 3 },
          width: { md: `calc(100% - ${drawerWidth}px)` },
          mt: { xs: '56px', md: '64px' },
          position: 'relative',
          paddingRight: { lg: `${chatWidth + 48}px` },
          transition: 'padding-right 0.3s ease',
          overflowX: 'hidden',
          overflowY: 'visible',
          WebkitOverflowScrolling: 'touch',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 20% 0%, rgba(255,255,255,0.12) 0%, transparent 60%)',
            pointerEvents: 'none',
            zIndex: 0,
          }
        }}
      >
        {children}
      </Box>

      {/* Чат-бот: на мобильных скрыт; фикс правого отступа уже отключен на xs/sm */}
      <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <ChatBot />
      </Box>
    </Box>
  );
};

export default Layout; 